import clsx from 'clsx';
import { type IconButtonStyleProps, iconButtonStyles } from './styles';

interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color' | 'size'> {
  onClick: () => void;
  icon: React.ReactNode;
  color?: IconButtonStyleProps['color'];
  size?: 'small' | 'medium' | 'xl';
}

export function IconButton({ onClick, icon, color = 'default', size = 'medium', ...props }: IconButtonProps) {
  return (
    <button
      {...props}
      onClick={onClick}
      className={clsx(iconButtonStyles({ color, size, disabled: Boolean(props.disabled) }), 'flex items-center justify-center')}
    >
      <div className="p-2 rounded-[8px]">{icon}</div>
    </button>
  );
}